module.exports = {"TXTCLI_Amount":{"id":"TXTCLI_Amount","defaultMessage":"Összeg","track":"Amount"}}